import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { HttpService } from '../../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class CadastroAdminGrupoService {

  constructor(private http: HttpClient, private httpService: HttpService) { }

  /* editarCadastro(id: any,data: any){
    return this.http.get(API + '/accessProfile/' + id, {params:data} );
  }*/

  editarCadastro(id: any, data: any) {
    return this.http.put(API + '/accessProfile/' + id, data);

  }

  cadastrarProduto(data: any, successHandle: Function, errorHandle: Function) {

    return this.httpService.doPost('/accessProfile', data, successHandle, errorHandle);

  } 


}
